module.exports = "/images/home-5.png?3fdf93fd2819c4edc2722176fcd7b646";